import { render, staticRenderFns } from "./WomensVersionConfig.vue?vue&type=template&id=11cbc4b7&scoped=true"
import script from "./WomensVersionConfig.vue?vue&type=script&lang=js"
export * from "./WomensVersionConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11cbc4b7",
  null
  
)

export default component.exports